/* eslint-disable class-methods-use-this */
import Component from '@bythepixel/component-loader';
import { clickIsInElement } from '@Utility';

export default class VehicleCard extends Component {
  static selector = '[data-comp-vehicle-card]';

  constructor(containerEl) {
    super(containerEl);
    this.attributesForForm = containerEl.dataset.formAttributes;
    this.modal = document.getElementById('vehicle-card-lead-form-modal');
    this.modalTrigger = containerEl.querySelector('[data-comp-modal-trigger]');
    this.productDetails = this.getProductDetails();
    this.groupTitleSingular = containerEl.dataset.productGroupTitleSingular;
    this.isRental = containerEl.dataset.productIsRental === 'true';
    this.isSold = containerEl.dataset.productIsSold === 'true';
    this.leadForm = document.querySelector('#vehicle-card-form form');
    this.showFinancingPreferencesInForm = containerEl.dataset.productShowFinancingPreferencesInForm === 'true';
    this.comparisonCheckbox = containerEl.querySelector(
      '.vehicle-card__comparison-checkbox',
    );
    this.removeButton = containerEl.querySelector('.vehicle-card__remove');
    this.leadFormEls = {
      title: this.modal.querySelector('.vehicle-card-form__header-title'),
      priceDetails: this.modal.querySelector(
        '.vehicle-card-form__price-details',
      ),
      price: this.modal.querySelector('.vehicle-card-form__header-price'),
      msrp: this.modal.querySelector('.vehicle-card-form__header-msrp'),
      location: this.modal.querySelector('.vehicle-card-form__contact-text'),
      locationPhone: this.modal.querySelector(
        '.vehicle-card-form__contact-number',
      ),
      financingField: this.leadForm.querySelector(
        '.tw-field__checkbox-dropdown',
      ),
    };

    this.mount();
  }

  hidePriceDetails() {
    return this.isSold;
  }

  attachListeners() {
    this.$container.addEventListener('click', (e) => {
      const { target } = e;
      const isModalTrigger = this.isInModalTrigger(target);

      // Comparison widgets
      const isComparisonCheckbox = this.comparisonCheckbox && clickIsInElement(e, this.comparisonCheckbox);
      const isRemoveButton = e.target === this.removeButton;
      const isComparisonElement = isComparisonCheckbox || isRemoveButton;

      const isLiteCard = this.$container.classList.contains('vehicle-card--lite');

      if (!isModalTrigger && !isComparisonElement && !isLiteCard) {
        window.location = this.productDetails.productUrl;
      }
    });

    this.modalTrigger.addEventListener('click', () => {
      this.setPriceDetailsVisibility();
      this.handleFinancingPreferencesField();
      this.updateLeadFormContent();
      this.updateLeadFormAttributes();
    });
  }

  handleFinancingPreferencesField() {
    const { financingField } = this.leadFormEls;

    if (!financingField) {
      return;
    }

    const CheckboxSelectComponent = financingField.component;

    CheckboxSelectComponent.reset();

    if (!this.showFinancingPreferencesInForm) {
      CheckboxSelectComponent.disable();
      financingField.classList.add('tw-field__checkbox-dropdown--hidden');

      return;
    }

    if (!this.isRental) {
      CheckboxSelectComponent.hideField('rent');
    } else {
      CheckboxSelectComponent.showField('rent');
    }

    CheckboxSelectComponent.enable();
    financingField.classList.remove('tw-field__checkbox-dropdown--hidden');
  }

  getParent(element) {
    return element.parentElement;
  }

  /**
   * Recursive function to determine whether an element is, or is a descendant of, the
   * modal trigger button.
   *
   * @param { HTMLElement } element
   */
  isInModalTrigger(element) {
    const parentEl = element.parentElement;
    const trigger = element.dataset.compModalTrigger || parentEl.dataset.compModalTrigger;
    const shouldStop = element.classList.contains('vehicle-card');

    // if either element has the compModalTrigger property, we're either the button, or in it
    if (trigger) {
      return true;
    }

    // we've gone too far, we're definitely not in the trigger
    if (shouldStop) {
      return false;
    }

    // else we keep scanning
    return this.isInModalTrigger(parentEl);
  }

  getProductDetails() {
    const productDetails = {
      productUrl: '',
      productTitle: '',
      productPrice: '',
      productMsrp: '',
      productLocation: '',
      productLocationPhone: '',
    };

    Object.keys(productDetails).forEach((key) => {
      const value = this.$container.dataset[key];
      productDetails[key] = value;
    });

    return productDetails;
  }

  updateLeadFormContent() {
    this.setFormHeaderContent();
    this.setFormContactInfo();
    this.updateTextAreaText();
  }

  setFormHeaderContent() {
    const { title, price, msrp } = this.leadFormEls;

    title.textContent = this.productDetails.productTitle;
    price.textContent = this.productDetails.productPrice;

    if (this.productDetails.productMsrp) {
      msrp.innerHTML = `${this.productDetails.productMsrp}`;
    }
  }

  setFormContactInfo() {
    const { groupTitleSingular } = this;
    const { location, locationPhone } = this.leadFormEls;
    let locationText = `Contact ${this.productDetails.productLocation}`;

    if (this.isSold) {
      locationText += ` to request a similar ${groupTitleSingular}.`;
    }

    location.textContent = locationText;
    locationPhone.textContent = this.productDetails.productLocationPhone;
  }

  updateTextAreaText() {
    const textArea = this.leadForm.querySelector('textarea[name=\'message\']');
    textArea.placeholder = `Hello, I'm interested in the ${this.productDetails.productTitle}...`;
  }

  updateLeadFormAttributes() {
    const targetInputs = [
      'color_exterior',
      'condition',
      'location',
      'make',
      'mileage',
      'model',
      'status',
      'stock_id',
      'submodel',
      'transmission_type',
      'vehicle_type',
      'vin',
      'year',
      'gd_location',
      'lead_destinations',
    ];

    const formAttributes = JSON.parse(this.attributesForForm);

    targetInputs.forEach((inputName) => {
      const input = this.leadForm.querySelector(`input[name=${inputName}]`);
      const value = formAttributes[inputName] || '';

      // reset to flush previously-set data
      input.setAttribute('value', '');

      input.setAttribute('value', value);
    });
  }

  setPriceDetailsVisibility() {
    return this.isSold
      ? this.leadFormEls.priceDetails.classList.add('hide')
      : this.leadFormEls.priceDetails.classList.remove('hide');
  }

  mount() {
    this.attachListeners();
  }
}
